import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { dispatchEvent } from 'fg-frontend/src/lib/dom';
import { getWebComponentInstance } from 'fg-frontend/src/webComponents/decorate';
import {execute} from "fg-frontend/src/partialUpdate/partialUpdate";

const fragments = {
	ITEM: '[data-fragment="TableShowDetailRow.item"]',
	LINK: '[data-fragment="TableShowDetailRow.link"]',
	CONTENT: '[data-fragment="TableShowDetailRow.content"]',
	CONTENT_WRAP: '[data-fragment="TableShowDetailRow.contentWrap"]',
};

class TableShowDetailRow extends WebComponent {
	constructor(props) {
		super(props);
		const {
			lastItem = null,
		} = props;
		this.state = {
			lastItem,
		};

		this.handleClickOnItem = this.handleClickOnItem.bind(this);
		this.handleClickOnLink = this.handleClickOnLink.bind(this);
	}

	didMount() {
		const {
			activeClass,
			contentClass,
		} = this.props;

		this.activeClass = activeClass;
		this.contentClass = contentClass;

		this.on('click', fragments.ITEM, this.handleClickOnItem);
		this.on('click', fragments.LINK, this.handleClickOnLink);

		this.itemElement = this.element.querySelectorAll(fragments.ITEM);
		this.contentElement = this.element.querySelector(fragments.CONTENT);
		this.contentWrapElement = this.element.querySelector(fragments.CONTENT_WRAP);

		const universalPreloaderComponentElement = document.getElementById('universalPreloader');
		this.universalPreloaderComponent = getWebComponentInstance(universalPreloaderComponentElement);
		document.addEventListener('afterContentsReplaced', () => {
			this.universalPreloaderComponent.handleOff(1);
		});
		/* automaticky otevri pokud je aspon jedna polozka*/
		if (this.itemElement.length > 0) {
			let _self = this;
			setTimeout(function () {
				_self.itemElement[0].querySelector('a').click();
			}, 200);
		} else {
		  /* automaticky otevri pokud je v url navratovy id, když je více položek*/
          let filterRowId = location.search.split('filterRowId=')[1];
          if (typeof (filterRowId) != 'undefined') {
              let filterRowIdClear = filterRowId.split('&')[0];
              if (filterRowIdClear.length > 0) {
                  let filterRow = this.element.querySelector('[data-filter-row-id="' + filterRowIdClear + '"]');
                  if(filterRow != null) {
					  setTimeout(function () {
	                    filterRow.click();
					  },200);
                  }
              }
          }
        }
	}

	handleClickOnItem = (e) => {
		const {
			lastItem,
		} = this.state;
		this.setState({
			lastItem,
		});
		e.preventDefault();

		if (!(e.target.tagName === 'A' || e.target.tagName === 'svg' || e.target.tagName === 'use')) {
			let el = e.currentTarget;
			if (el.classList.contains("cursor-pointer")) {
				let targetClick = el.querySelector('a');
				targetClick.click();
			}
		}
	};

	handleClickOnLink = (e) => {
		const {
			lastItem,
		} = this.state;
		this.setState({
			lastItem,
		});
		e.preventDefault();
		this.universalPreloaderComponent.handleOn(1);
		this.initItem(e);
	};

	initItem = (e) => {
		const {
			lastItem,
		} = this.state;
		e.preventDefault;
		let el = e;
		el = e.target.parentElement.parentElement.parentElement;
		if (e.target.tagName === 'svg') {
			el = el.parentElement;
		}
		if (e.target.tagName === 'use') {
			el = el.parentElement.parentElement;
		}

		if (lastItem && lastItem !== el) {
			this.closeItem(lastItem);
		}

		if (!el.classList.contains(this.activeClass)) {
			this.openItem(el);
		} else {
			this.closeItem(el);
		}
	};

	openItem = (el) => {
		this.setState({
			lastItem: el,
		});
		el.classList.add(this.activeClass);
		let nextRow = document.createElement('tr');
		nextRow.classList.add(this.contentClass);
		nextRow.innerHTML = '<td colspan="2"></td>';
		el.parentNode.insertBefore(nextRow, el.nextSibling);
		nextRow.firstElementChild.appendChild(this.contentElement);
	};

	closeItem = (el) => {
		this.setState({
			lastItem: null
		});
		el.classList.remove(this.activeClass);
		let nextRow = el.nextSibling;
		this.universalPreloaderComponent.handleOff(1);
		this.contentWrapElement.appendChild(nextRow);
	};

	willUnMount() {
		this.elements = null;
	}

}

TableShowDetailRow.defaultProps = {
	activeClass: 'active',
	contentClass: 'table__detail',
};

export default TableShowDetailRow;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/TableShowDetailRow.js